import { ArrowPathIcon, BookOpenIcon, RectangleGroupIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/outline"
import { Navigate, Route, Routes } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import { LanguageMaster } from "./LanguageMaster"
import { WidgetMaster } from "./WidgetMaster"
import RouteKeys from '../../../constants/route-keys'
import TemplatemMaster from "./templateType"
import ToolsList from "./Tools/ToolsList"
import ToolsFormPage from "./Tools/ToolsFormPage"
import AppVersionMaster from "./AppVersionMaster"

const _routes: RouteElement[] = [
    {
        route: 'language-master',
        title: 'Language Master',
        key: RouteKeys.LANGUAGE,
        component: LanguageMaster,
        icon: BookOpenIcon,
        display: true
    },
    {
        route: 'widget-master',
        title: 'Widget Master',
        key: RouteKeys.WIDGET,
        component: WidgetMaster,
        icon: RectangleGroupIcon,
        display: true
    },
    {
        route: 'template-master',
        title: 'Template Type Master',
        key: RouteKeys.TEMPLATE_MASTER,
        component: TemplatemMaster,
        icon: RectangleGroupIcon,
        display: true
    },
    {
        route: 'tools-master',
        title: 'Tools Master',
        key: RouteKeys.TOOLS,
        component: ToolsList,
        icon: WrenchScrewdriverIcon,
        display: true
    },
    {
        route: 'app-version-master',
        title: 'App Version Master',
        key: RouteKeys.APP_VERSION,
        component: AppVersionMaster,
        icon: ArrowPathIcon,
        display: true
    }
    // {
    //     route: 'category-master',
    //     title: 'Category Master',
    //     key: RouteKeys.CATEGORY,
    //     component: CategoryMaster,
    //     icon: Squares2X2Icon,
    //     display: true
    // }
]

const MasterSettings = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes}/>
            <div className="p-3">
                <Routes>
                    <Route path='' element={<Navigate to={_routes[0].route} replace/>}>
                    </Route>
                    <Route path='tools-master/create' element={<ToolsFormPage />} />
                    <Route path='tools-master/edit/:toolId' element={<ToolsFormPage />} />
                    <Route path='tools/create' element={<ToolsFormPage />} />
                    <Route path='tools/edit/:toolId' element={<ToolsFormPage />} />
                    {_routes.map(route => (
                        <Route path={route.route} key={'master' + route.route} element={<route.component />} />
                    ))}
                </Routes>
            </div>
        </div>
    )
}

export default MasterSettings

